// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e04dca02","239":"21891578","455":"d1dafbcf"}[chunkId] + ".chunk.js";
};